var exports = {
  "k": "x93eb46d8--3e1dd7--container",
  "K": "x93eb46d8--3e1dd7--icon",
};

module.exports = exports;
